/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { Menu } from '@neo4j-ndl/react';
import { DocumentIconOutline, FolderIconSolid } from '@neo4j-ndl/react/icons';
import { TreeView } from '@neo4j-ndl/react/next';
import { useState } from 'react';

const Component = () => {
  const [expanded, setExpanded] = useState<Record<string, boolean>>({});
  const [selected, setSelected] = useState<string | null>(null);

  const toggle = (key: string) =>
    setExpanded((prev) => ({ ...prev, [key]: !prev[key] }));

  return (
    <TreeView ariaLabel="Project files">
      <TreeView.Item
        title="src"
        hasChildren
        isExpanded={expanded['src']}
        onExpandedChange={() => toggle('src')}
        isSelected={selected === 'src'}
        onSelectedChange={() => setSelected('src')}
        leadingVisual={<FolderIconSolid />}
        actionMenuItems={
          <>
            <Menu.Item
              title="New File"
              onClick={() => alert('New file in src')}
            />
            <Menu.Item title="Rename" onClick={() => alert('Rename src')} />
            <Menu.Item title="Delete" onClick={() => alert('Delete src')} />
          </>
        }
      >
        <TreeView.Item
          title="index.ts"
          isSelected={selected === 'index'}
          onSelectedChange={() => setSelected('index')}
          leadingVisual={<DocumentIconOutline />}
          actionMenuItems={
            <>
              <Menu.Item title="Open" onClick={() => alert('Open index.ts')} />
              <Menu.Item
                title="Rename"
                onClick={() => alert('Rename index.ts')}
              />
              <Menu.Item
                title="Delete"
                onClick={() => alert('Delete index.ts')}
              />
            </>
          }
        />
        <TreeView.Item
          title="utils.ts"
          isSelected={selected === 'utils'}
          onSelectedChange={() => setSelected('utils')}
          leadingVisual={<DocumentIconOutline />}
          actionMenuItems={
            <>
              <Menu.Item title="Open" onClick={() => alert('Open utils.ts')} />
              <Menu.Item
                title="Rename"
                onClick={() => alert('Rename utils.ts')}
              />
              <Menu.Item
                title="Delete"
                onClick={() => alert('Delete utils.ts')}
              />
            </>
          }
        />
      </TreeView.Item>
      <TreeView.Item
        title="tests"
        hasChildren
        isExpanded={expanded['tests']}
        onExpandedChange={() => toggle('tests')}
        isSelected={selected === 'tests'}
        onSelectedChange={() => setSelected('tests')}
        leadingVisual={<FolderIconSolid />}
        actionMenuItems={
          <>
            <Menu.Item
              title="Run Tests"
              onClick={() => alert('Run all tests')}
            />
            <Menu.Item
              title="New Test"
              onClick={() => alert('New test in tests')}
            />
            <Menu.Item title="Delete" onClick={() => alert('Delete tests')} />
          </>
        }
      >
        <TreeView.Item
          title="index.test.ts"
          isSelected={selected === 'index-test'}
          onSelectedChange={() => setSelected('index-test')}
          leadingVisual={<DocumentIconOutline />}
          actionMenuItems={
            <>
              <Menu.Item
                title="Run"
                onClick={() => alert('Run index.test.ts')}
              />
              <Menu.Item
                title="Rename"
                onClick={() => alert('Rename index.test.ts')}
              />
              <Menu.Item
                title="Delete"
                onClick={() => alert('Delete index.test.ts')}
              />
            </>
          }
        />
        <TreeView.Item
          title="utils.test.ts"
          isSelected={selected === 'utils-test'}
          onSelectedChange={() => setSelected('utils-test')}
          leadingVisual={<DocumentIconOutline />}
          actionMenuItems={
            <>
              <Menu.Item
                title="Run"
                onClick={() => alert('Run utils.test.ts')}
              />
              <Menu.Item
                title="Rename"
                onClick={() => alert('Rename utils.test.ts')}
              />
              <Menu.Item
                title="Delete"
                onClick={() => alert('Delete utils.test.ts')}
              />
            </>
          }
        />
      </TreeView.Item>
      <TreeView.Item
        title="README.md"
        isSelected={selected === 'readme'}
        onSelectedChange={() => setSelected('readme')}
        leadingVisual={<DocumentIconOutline />}
        actionMenuItems={
          <>
            <Menu.Item title="Open" onClick={() => alert('Open README.md')} />
            <Menu.Item
              title="Rename"
              onClick={() => alert('Rename README.md')}
            />
            <Menu.Item
              title="Delete"
              onClick={() => alert('Delete README.md')}
            />
          </>
        }
      />
    </TreeView>
  );
};

export default Component;
